// extracted by mini-css-extract-plugin
export var closeButton = "_mo-1";
export var closeX = "_mo-3";
export var container = "_mo-0";
export var image = "_mo-2";